var baseSpacingPxUnit = 8;
export var spacing = function spacing(multiplier) {
  return multiplier === 'auto' ? 'auto' : "".concat(multiplier * baseSpacingPxUnit, "px");
};
export var padding = function padding(descriptor) {
  if (typeof descriptor === 'number') {
    return "padding: ".concat(spacing(descriptor), ";");
  }
  var paddingStyles = '';
  if (typeof descriptor.hor !== 'undefined') {
    paddingStyles += "padding-left: ".concat(spacing(descriptor.hor), "; padding-right: ").concat(spacing(descriptor.hor), ";");
  }
  if (typeof descriptor.ver !== 'undefined') {
    paddingStyles += "padding-top: ".concat(spacing(descriptor.ver), "; padding-bottom: ").concat(spacing(descriptor.ver), ";");
  }
  if (typeof descriptor.top !== 'undefined') {
    paddingStyles += "padding-top: ".concat(spacing(descriptor.top), ";");
  }
  if (typeof descriptor.bottom !== 'undefined') {
    paddingStyles += "padding-bottom: ".concat(spacing(descriptor.bottom), ";");
  }
  if (typeof descriptor.left !== 'undefined') {
    paddingStyles += "padding-left: ".concat(spacing(descriptor.left), ";");
  }
  if (typeof descriptor.right !== 'undefined') {
    paddingStyles += "padding-right: ".concat(spacing(descriptor.right), ";");
  }
  return paddingStyles;
};
export var margin = function margin(descriptor) {
  if (typeof descriptor === 'number') {
    return "margin: ".concat(spacing(descriptor), ";");
  }
  var marginStyles = '';
  if (typeof descriptor.hor !== 'undefined') {
    marginStyles += "margin-left: ".concat(spacing(descriptor.hor), "; margin-right: ").concat(spacing(descriptor.hor), ";");
  }
  if (typeof descriptor.ver !== 'undefined') {
    marginStyles += "margin-top: ".concat(spacing(descriptor.ver), "; margin-bottom: ").concat(spacing(descriptor.ver), ";");
  }
  if (typeof descriptor.top !== 'undefined') {
    marginStyles += "margin-top: ".concat(spacing(descriptor.top), ";");
  }
  if (typeof descriptor.bottom !== 'undefined') {
    marginStyles += "margin-bottom: ".concat(spacing(descriptor.bottom), ";");
  }
  if (typeof descriptor.left !== 'undefined') {
    marginStyles += "margin-left: ".concat(spacing(descriptor.left), ";");
  }
  if (typeof descriptor.right !== 'undefined') {
    marginStyles += "margin-right: ".concat(spacing(descriptor.right), ";");
  }
  return marginStyles;
};